import { onSnapshot as firestoreOnSnapshot } from 'firebase/firestore'

// Permet aux méthodes "listen" asynchrones (qui doivent d'abord résoudre le chemin de la collection)
// de renvoyer IMMÉDIATEMENT une fonction de désabonnement.
// Si on se désabonne avant que le listener Firestore ne soit créé, il ne sera jamais créé.
export default function lazyListener(body) {
  let unsubs = []
  let cancelled = false

  const onSnapshot = (...args) => {
    if (cancelled) return () => {}
    const unsub = firestoreOnSnapshot(...args)
    unsubs.push(unsub)
    return unsub
  }

  Promise.resolve()
    .then(() => body(onSnapshot))
    .catch(error => console.error('[lazyListener]', error))

  return () => {
    cancelled = true
    unsubs.forEach(unsub => unsub())
    unsubs = []
  }
}
